import moment from "moment"
import type { Headers } from "react-csv/lib/core"
import type { I_VehicleLeaseGridView } from "src/common_interfaces/I_VehicleLease"
import { rateToPercent } from "../fleetUtility"

export const LEASE_CSV_HEADERS: Headers = [
	{ label: "VIN", key: "VinNumber" },
	{ label: "Unit #", key: "UnitNumber" },
	{ label: "Date Received", key: "DateReceived" },
	{ label: "Capitalized Amount", key: "CapitalizedAmount" },
	{ label: "Interest Rate (%)", key: "InterestRate" },
	{ label: "Lease Depreciation (%)", key: "LeaseDepreciationRate" },
	{ label: "Mgmt Fee (%)", key: "MgmtFeePercent" },
	{ label: "Maint Pgm Mo Exp", key: "MaintenanceProgramMonthly" },
	{ label: "Lease Length (Months)", key: "LeaseLength" },
	{ label: "Period Zero Lease Exp", key: "PeriodZeroLeaseExpense" },
	{ label: "Pd Zero Depr", key: "PeriodZeroDepreciation" },
	{ label: "End of Lease Svc Chg", key: "EndOfLeaseServiceCharge" },
	{ label: "Sls Tx Per Mo", key: "SalesTaxPerMonth" },
	{ label: "Month of 1st Pmt", key: "MonthOfFirstPayment" },
	{ label: "Payment", key: "TotalMonthlyLeasePayment" },
	{ label: "Sls Tx on Incentive", key: "SalesTaxOnIncentive" },
	{ label: "EFM Negotiated Rate", key: "EFMNegotiatedRate" },
	{ label: "Down Payment", key: "DownPayment" },
	{ label: "Gain on Prior Vehicle", key: "GainOnPriorVehicle" },
	{ label: "Monthly Exp Override", key: "MonthlyExpenseOverride" },
]

export const toLeaseCsvRow = (vh: I_VehicleLeaseGridView) => ({
	VinNumber: vh.Lease.VinNumber,
	UnitNumber: vh.Lease.UnitNumber,
	DateReceived: csvDate(vh.Lease.DateReceived),
	CapitalizedAmount: vh.Lease.CapitalizedAmount,
	InterestRate: rateToPercent(vh.Lease.InterestRate),
	LeaseDepreciationRate: rateToPercent(vh.Lease.LeaseDepreciationRate),
	MgmtFeePercent: rateToPercent(vh.Lease.MgmtFeePercent),
	MaintenanceProgramMonthly: vh.Lease.MaintenanceProgramMonthly,
	LeaseLength: vh.Lease.LeaseLength,
	PeriodZeroLeaseExpense: vh.Lease.PeriodZeroLeaseExpense,
	PeriodZeroDepreciation: vh.Lease.PeriodZeroDepreciation,
	EndOfLeaseServiceCharge: vh.Lease.EndOfLeaseServiceCharge,
	SalesTaxPerMonth: vh.Lease.SalesTaxPerMonth,
	MonthOfFirstPayment: csvDate(vh.Lease.MonthOfFirstPayment),
	TotalMonthlyLeasePayment: parseFloat(
		vh.Calculations.TotalMonthlyLeasePayment.toFixed(2),
	),
	SalesTaxOnIncentive: vh.Lease.SalesTaxOnIncentive,
	EFMNegotiatedRate: vh.Lease.EFMNegotiatedRate,
	DownPayment: vh.Lease.DownPayment,
	GainOnPriorVehicle: vh.Lease.GainOnPriorVehicle,
	MonthlyExpenseOverride: vh.Lease.MonthlyExpenseOverride,
})

export const csvDate = (d: string): string => moment(d).format("M/D/YYYY")
